export default {
  outlined: {
    minHeight: '55px',
    backgroundColor: '#f3f3f3',
  },
  contained: {
    minHeight: '55px',
    backgroundColor: '#f3f3f3',
  },
};
